import { Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { EventManagerService } from '../../services/database/event/eventmanager.service';

@Component({
  selector: 'ngx-salesdetail',
  templateUrl: './salesdetail.component.html',
  styleUrls: ['./salesdetail.component.scss']
})
export class SalesdetailComponent implements OnInit {
  eventId: string;
  authKey: string;
  authToken: string;
  constructor(
    private route: ActivatedRoute,
    private eventManagerService: EventManagerService,
    private authService: AuthService
    ) { }

  ngOnInit(): void {
    this.eventId = this.route.snapshot.paramMap.get('eventId');
    this.authService.get().subscribe((user) => {
      this.eventManagerService.updateEventManager(
        this.eventId,
        user.uid,
        null,
        null
      )
      this.eventManagerService.getEventManager(this.eventId, user.uid).subscribe((eventManager) => {
        this.authKey = eventManager.authKey;
        this.authToken = eventManager.authToken;
      })
    })
  }
}
